








































































































































import { Vue, Component } from "vue-property-decorator";
import { DataTableHeader } from "vuetify";
import { $api } from "@/services/ApiService";
import { ThinCertificate, CertificateState, Certificate } from "bancojs";
import AgDataTable, { AgDataTableOptions } from "@/components/AgDataTable.vue";

@Component({
  components: {
    AgDataTable,
  },
})
export default class AdminCertificatesIndex extends Vue {
  async created() {
    await this.loadData();
  }

  async loadData() {
    try {
      this.table.loading = true;
      const res = await $api.client.admin.certificates.find({}).toPromise();
      this.table.data = res.content;
    } catch (err) {
      console.log(err);
    } finally {
      this.table.loading = false;
    }
  }

  getStateString(val: CertificateState) {
    return val === "ACTIVE"
      ? "Activo"
      : val === "INACTIVE"
      ? "Inactivo"
      : "Eliminado";
  }

  openRemove(item: ThinCertificate) {
    this.table.selected = item;
  }

  closeRemove() {
    this.table.selected = null;
    this.dialog.valid = false;
    this.dialog.confirm = null;
  }

  get removeDialog() {
    return !!this.table.selected;
  }

  rules = {
    required: (val: any) => !!val || "Campo requerido.",
    matches: (val: string) =>
      (this.table.selected && val == "eliminar") ||
      "La confirmación no es correcta.",
  };

  async removeUser(fingerprint: string) {
    try {
      this.dialog.loading = true;
      await $api.client.admin.certificates.destroy(fingerprint).toPromise();
      this.dialog.loading = false;
      this.closeRemove();
      await this.loadData();
    } catch (err) {
      console.log(err);
      this.dialog.loading = false;
      this.closeRemove();
    }
  }

  dialog: {
    loading: boolean;
    valid: boolean;
    confirm: string | null;
  } = {
    loading: false,
    valid: false,
    confirm: null,
  };

  table: {
    loading: boolean;
    selected: ThinCertificate | null;
    data?: ThinCertificate[];
    options: AgDataTableOptions[];
    headers?: DataTableHeader[];
  } = {
    loading: true,
    selected: null,
    data: undefined,
    options: [
      {
        header: {
          text: "#",
          value: "$index",
          width: 60,
          filterable: false,
          sortable: false,
        },
        row: {
          type: "INDEX",
        },
      },
      {
        header: {
          text: "Fingerprint",
          value: "fingerprint",
          class: "text-no-wrap",
          width: 500,
        },
        row: {
          type: "LINK",
          to: "{fingerprint}/edit",
          append: true,
        },
      },
      {
        header: {
          text: "Dueño",
          value: "user_id",
          class: "text-no-wrap",
        },
        row: {
          type: "LINK",
          to: "/admin/users/{user_id}/edit",
          append: true,
        },
      },
      {
        header: {
          text: "Llave",
          value: "key_id",
          class: "text-no-wrap",
        },
        row: {
          type: "LINK",
          to: "/admin/keys/{key_id}/edit",
          append: true,
        },
      },
      {
        header: {
          text: "Estado",
          value: "state",
          class: "text-no-wrap",
        },
        row: {
          type: "CHIP",
          label: true,
          color: {
            ACTIVE: "success",
            INACTIVE: "warn",
            DELETED: "error",
          },
          transform: this.getStateString,
        },
      },
      {
        header: {
          text: "",
          class: "text-no-wrap",
          value: "$options",
          sortable: false,
          filterable: false,
        },
        row: {
          type: "OPTIONS",
          options: [
            {
              label: "Editar",
              icon: "mdi-pencil",
              link: "{fingerprint}/edit",
              append: true,
            },
            {
              label: "Eliminar",
              icon: "mdi-delete",
              action: (item: ThinCertificate) => {
                this.openRemove(item);
              },
            },
          ],
        },
      },
    ],
  };
}
